module.exports = __webpack_public_path__ + "img/stock0.62efc33d.png";